<script setup>
import { onMounted } from 'vue'
import { useFormulario } from '@/composables/useFormulario'
import FormularioCadastro from '@/components/base/formulario/FormularioCadastro.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'

// O itemParaEditar virá sempre null neste módulo
const props = defineProps({
  itemParaEditar: {
    type: Object,
    default: null
  },
  modeloVazio: {
    type: Object,
    default: () => ({
      dataFechada: '',
      idOrganizacao: null // GUARDIÃO: Adicionado para sustentar o Spread Operator seguro
    })
  }
})

const emit = defineEmits(['itemAtualizado', 'cancelar', 'changesDetected', 'show-notification'])

const {
  item,
  isLoading,
  entityInfo,
  submitForm,
  handleCancel
} = useFormulario(props, emit)

async function salvar () {
  // GUARDIÃO: O "if (!item.dataFechada)" foi removido! A Validação Híbrida (Robô do DOM)
  // já garante que o formulário não passa daqui se o campo estiver vazio.

  // GUARDIÃO: Com DateOnly no backend, enviamos a string 'YYYY-MM-DD' pura via Spread Operator!
  const payload = {
    ...item.value
  }

  await submitForm('FechamentosPeriodosFinanceiros', 'idFechamentoPeriodoFinanceiro', payload)
}

onMounted(() => {
  // Inicializa o form vazio obrigatoriamente
  item.value.dataFechada = ''
})
</script>

<template>
  <FormularioCadastro
    module-name="Lançamento de Fechamento"
    :is-loading="isLoading"
    :is-editing="false"
    :entity-info="entityInfo"
    @submit="salvar"
    @cancelar="handleCancel"
  >

    <!-- Aviso de Impacto Operacional -->
    <div class="alert alert-warning d-flex align-items-center mb-4 border-0 shadow-sm">
      <i class="bi bi-exclamation-triangle-fill fs-3 me-3 text-warning"></i>
      <div>
        <h6 class="alert-heading mb-1 fw-bold">Ação Permanente</h6>
        <p class="mb-0 small">
          Lançar uma nova data inativará o fechamento atual. O sistema bloqueará qualquer movimentação ou edição de documentos anteriores a esta data. <br>
          <strong>Esta ação não gera histórico editável e não pode ser desfeita.</strong> Para "reabrir", lance uma data retroativa.
        </p>
      </div>
    </div>

    <!-- Frame Único: DATA DO FECHAMENTO -->
    <div class="card mb-4">
      <div class="card-header">
        <h5 class="mb-0">Dados do Fechamento</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <CampoInput
              id="dataFechada"
              label="Período Fechado Até:"
              type="date"
              v-model="item.dataFechada"
              required
            />
          </div>
          <div class="col-md-9 d-flex align-items-end pb-2">
             <span class="text-body-secondary small fst-italic">
               Ex: "31/01/2026" garante que tudo ocorrido em Janeiro e anos anteriores está bloqueado.
             </span>
          </div>
        </div>
      </div>
    </div>

  </FormularioCadastro>
</template>
